import { ContentLanguageTranslation } from '../../../types/InternalAnalystComment'
import { UploadedFile } from '../../../types/UploadedFile'

export enum EditorialCardStatus {
  Published = 1,
  Draft = 2,
}

export enum EditorialCardActionType {
  None = 'none',
  OpenSaasPage = 'open_saas_page',
}

// The card's place in the customer e-mail digest.
export enum StickyEmail {
  No = 0,
  First = 1,
  Second = 2,
  Last = 3,
}

export type EditorialCardAction = {
  type: EditorialCardActionType | string
  target?: string
  label?: ContentLanguageTranslation
}

export type EditorialCardEntryData = {
  content?: ContentLanguageTranslation
  // Stored as `{}` on one legacy card.
  image?: UploadedFile | Partial<UploadedFile> | null
  action?: EditorialCardAction
  sticky?: boolean
  stickyEmail?: number
  // Written by the backend once a published card was posted to Slack.
  notifiedSlack?: boolean
}

export type EditorialCard = {
  id: string
  type: 'editorial'
  titles: ContentLanguageTranslation
  subtitles: ContentLanguageTranslation
  entryData: EditorialCardEntryData
  market: string
  publishedAt: number
  status: EditorialCardStatus
  createdAt: number
  createdBy: string | null
  modifiedAt: number
  modifiedBy: string | null
  source?: string | null
  baseType?: string | null
  subType?: string | null
  title?: string | null
  subtitle?: string | null
  saasLink?: string | null
  priority?: number
  hide?: boolean
  link?: string | null
  gameId?: string | null
}

// `PUT i/entries` creates without an `id` and updates with one. The backend replaces `entryData` as sent.
export type EditorialCardMutation = {
  id?: string
  type: 'editorial'
  titles: ContentLanguageTranslation
  subtitles: ContentLanguageTranslation
  entryData: EditorialCardEntryData
  market: string
  publishedAt: number
  status: EditorialCardStatus
  createdAt: number
  createdBy: string | null
  modifiedBy?: string
}
